/**
 * UPLOAD WIZARD REDUX ACTIONS
 *
 * Description here.
 *
 * @version 0.1
 */

import reduxStore from './../../reduxStore';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import { hashHistory } from 'react-router';

import headerActions from './../../reusable/Header/Header.actions';
import api from './../../api/Common.api';
import commonActions from './../../api/Common.actions';

// Define action constants
export const UPLOAD_INITIAL_PHASE = 'UPLOAD_INITIAL_PHASE';
export const UPLOAD_FILE_SELECTED = 'UPLOAD_FILE_SELECTED';
export const UPLOAD_STARTED = 'UPLOAD_STARTED';
export const UPLOAD_CANCELED = 'UPLOAD_CANCELED';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE';
export const UPLOAD_FAILURE_SUBSCRIPTION_EXCEEDED = 'UPLOAD_FAILURE_SUBSCRIPTION_EXCEEDED';
export const SET_CHECK_FORMATTING_RECORDS_COUNT = 'SET_CHECK_FORMATTING_RECORDS_COUNT';

const actions = {

    uploadFileSelected: (file) => {
        reduxStore.dispatch({
            type:    UPLOAD_FILE_SELECTED,
            payload: file
        });
    },

    startUpload:  () => {reduxStore.dispatch({type: UPLOAD_STARTED});},
    cancelUpload: () => {reduxStore.dispatch({type: UPLOAD_CANCELED});},

    resetUploadToInitial: () => {

        let uploadId = reduxStore.getState().batchUpload.uploadId;

        if (uploadId) {
            xhr.delete({
                url:     '/api/template/temp-entities/' + uploadId
            }).then(() => {
                return api.getPendingUpload()
                    .then((response) => {
                    commonActions.updatePendingUploads(response);
                });
            }).catch((error) => {
                xhr.handleAllErrors(error);
            });
        }
        reduxStore.dispatch({type: 'UPLOAD_INITIAL_PHASE'});
        headerActions.updateHeader('batchUpload');

    },

    continueAndCommit: () => {

        var uploadId = reduxStore.getState().batchUpload.uploadId;
        reduxStore.dispatch({type: 'SHOW_SPINNER'});


        xhr.post({
            url:     '/api/entities/commit/' + uploadId
        }).then((response) => {
            hashHistory.push('/review-companies');
            reduxStore.dispatch({type: 'HIDE_SPINNER'});
        }).then(() => {
            return api.getPendingUpload()
                .then((response) => {
                    commonActions.updatePendingUploads(response);
                });
        }).catch((error) => {
            utils.logError(error, 'BatchUpload.actions.continueAndCommit(): ');
            reduxStore.dispatch({type: 'HIDE_SPINNER'});
            xhr.handleAllErrors(error);
        });

    },

    uploadSuccess: (uploadId) => {
        reduxStore.dispatch(
            {
                type:    UPLOAD_SUCCESS,
                payload: uploadId
            }
        );

        api.getPendingUpload()
            .then((response) => {
                commonActions.updatePendingUploads(response);
            }).catch((error) => {
            xhr.handleAllErrors(error);
        });
        headerActions.updateHeader('checkFormatting');

    },

    uploadFailure: (error) => {

        if (error.specialErrors.length > 0) {

            for (let i = 0; i < error.specialErrors.length; i++) {

                if (error.specialErrors[i] == 'SUBSCRIPTION_CAP_EXCEEDED') {
                    reduxStore.dispatch({
                        type: 'UPLOAD_FAILURE_SUBSCRIPTION_EXCEEDED',
                        payload: true
                    });
                    headerActions.updateHeader('subscriptionPlanExceeded');
                    return;
                }
            }

        }

        reduxStore.dispatch(
            {
                type:    UPLOAD_FAILURE,
                payload: error.uploadId
            }
        );
        headerActions.updateHeader('fileReadingError');

    },

    handleUpload: () => {

        var file = reduxStore.getState().batchUpload.file;

        actions.startUpload();

        xhr.post({
            url:     '/api/template/upload',
            files:   [
                {
                    name:    'companiesSpreadsheet',
                    content: file
                }
            ]
        }).then((response) => {
            actions.uploadSuccess(response.body.uploadId);
        }).catch((error) => {
            if (error.status == 401) {
                reduxStore.dispatch({
                    type: 'UPLOAD_INITIAL_PHASE'
                });
            } else if(error.status === 400) {
                if (error.response && error.response.body && typeof error.response.body.uploadId === 'string') {
                    actions.uploadFailure(error.response.body);
                } else {
                    xhr.handleAllErrors(error);
                }
            } else {
                xhr.handleAllErrors(error);
            }
        });

    },

    checkFormattingEntriesCount: (uploadId) => {

        let changeRecordsCount = (entriesCount) => {
            reduxStore.dispatch({
                type:    SET_CHECK_FORMATTING_RECORDS_COUNT,
                payload: entriesCount
            });
            reduxStore.dispatch({type: 'HIDE_SPINNER'});
        };

        if (typeof uploadId === 'string') {

            xhr.get({
                url: '/api/template/temp-entities/' + uploadId + '/count'
            }).then((response) => {
                let entriesCount = isNaN(response.body) ? 'N/A' : response.body;
                changeRecordsCount(entriesCount);
            }).catch((error) => {
                if (error.status === 400) {
                    changeRecordsCount('N/A');
                } else {
                    xhr.handleAllErrors(error);
                }
            });

        } else {
            changeRecordsCount('N/A');
        }

    }

};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/BatchUpload.actions.js